import { ReactNode } from 'react';

export enum SettingsMenuItems {
  NONE = 'teams-and-users',
  TEAMS_AND_USERS = 'teams-and-users',
  JOBS = 'jobs',
  ANALYTICS = 'analytics',
  CRM = 'crm',
  ACCOUNT = 'account',
  DATA_PRIVACY = 'data-privacy',
  APPS_AND_INTEGRATIONS = 'apps-and-integrations',
  CAREER_PAGES = 'career-pages',
  HELP_AND_KNOWLEDGE = 'help-and-knowledge',
  AUTOMATION = 'automation',
  CONFIGURE_EMAIL = 'configure-email',
  VMS = 'vms',
  INVOICE_MODULE = 'invoice-module',
  CLIENTS = 'clients',
  PLACEMENT = 'placements',
  WORKSPACE_SETTINGS = 'workspace-settings',
  FAQS = 'faqs',
  LEADS = 'leads',
}

export interface ISettingsMenuOption {
  icon?: ReactNode;
  label: string;
  url: string;
  description?: string;
  openInNewTab?: boolean;
  SKU?: string;
}
